export default __webpack_public_path__ + "static/media/050_brake_01.97b405d8.mp3";